import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { ToastrModule } from 'ngx-toastr';
import { NgxMaskModule } from 'ngx-mask';
import { LottieModule } from 'ngx-lottie';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './core/shared/shared.module';
import { ComponentsModule } from './core/components/components.module';

import { coreReducer } from './core/store/reducers';
import { CoreEffects } from './core/store/effects';
import { metaReducers } from './core/store/meta-reducers';

import { AuthInterceptor } from './core/interceptors/auth/auth.interceptor';
import { ErrorHandlerInterceptor } from './core/interceptors/error-handler/error-handler.interceptor';

import { environment } from 'src/environments/environment';

import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

import { LOCALE_ID } from '@angular/core';

registerLocaleData(localePt, 'pt-BR');

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    SharedModule,
    ComponentsModule,
    StoreModule.forRoot({ core: coreReducer }, { metaReducers }),
    EffectsModule.forRoot([CoreEffects]),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
    ToastrModule.forRoot({ positionClass: 'toast-top-right', preventDuplicates: true }),
    NgxMaskModule.forRoot(),
    LottieModule.forRoot({ player: () => import('lottie-web') }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorHandlerInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
